import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { doSignOut } from '../../firebase/auth';
import { HomeIcon, Cog6ToothIcon,  ArrowRightOnRectangleIcon } from '@heroicons/react/20/solid';
import { makeAuthenticatedRequest } from "../../utils/apiRequest";
import { useAuth } from "../../contexts/authContext";
import { MagnifyingGlassIcon } from '@heroicons/react/20/solid';
import { useDarkMode } from "../../contexts/darkModeContext";
import { MoonIcon, SunIcon } from "@heroicons/react/24/outline";







const User = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { token, currentUser } = useAuth();

  const itineraryRefs = useRef({});
  const [showSettings, setShowSettings] = useState(false);

  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [menuOpenIndex, setMenuOpenIndex] = useState(null); // State for menu open index

  const updatedItineraryId = location.state?.updatedItineraryId;

  const [isDuplicatePopupOpen, setIsDuplicatePopupOpen] = useState(false);
const [selectedCustomerIdForDuplication, setSelectedCustomerIdForDuplication] = useState("");
const [itineraryToDuplicate, setItineraryToDuplicate] = useState(null);
const [customers, setCustomers] = useState([]); // Store customer list

const [isDuplicating, setIsDuplicating] = useState(false);

const [searchTerm, setSearchTerm] = useState("");

const { isDarkMode, toggleDarkMode } = useDarkMode();

const [openMenuId, setOpenMenuId] = useState(null); // To track which itinerary's menu is open
const [approvingItineraries, setApprovingItineraries] = useState(new Set());



  const menuRef = useRef(null); // Ref for the dropdown menu
  const buttonRef = useRef(null); // Ref for the three dots button

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close the dropdown if the click is outside the dropdown and the button
      if (menuRef.current && !menuRef.current.contains(event.target) && !buttonRef.current.contains(event.target)) {
        setOpenMenuId(null); // Close dropdown
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside); // Cleanup the event listener
    };
  }, []);

  const [currentDateTime, setCurrentDateTime] = useState(new Date().toLocaleString());


  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDateTime(new Date().toLocaleString());
    }, 1000); // Update every second
  
    // Cleanup the interval on component unmount
    return () => clearInterval(interval);
  }, []);
  


useEffect(() => {
  const fetchCustomers = async () => {
    if (!token) {
      setError("Authorization token is missing.");
      return;
    }

    console.log("Customer Using token:", token); // Added to print the token
    try {
      const response = await makeAuthenticatedRequest(
        "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_customer_data",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch customers.");
      }
      const result = await response.json();
      setCustomers(result.data || []);
    } catch (err) {
      setError(err.message);
    }
  };
  fetchCustomers();
}, [token]);

const handleDuplicateItinerary = async () => {
  try {
    setIsDuplicating(true); // Start loading
 
    if (!itineraryToDuplicate || !selectedCustomerIdForDuplication) {
      alert("Please select a customer.");
      setIsDuplicating(false);
      return;
    }
 
    if (!token) {
      alert("Authorization token is missing.");
      setIsDuplicating(false);
      return;

    }

    console.log("Itinerary Data Using token:", token); // Added to print the token
 
    // Fetch the itinerary data
    const response = await makeAuthenticatedRequest(
      "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_itinerary_data",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ itinerary_id: itineraryToDuplicate.itinerary_id }),
      }
    );
 
    if (!response.ok) {
      throw new Error("Failed to fetch itinerary for duplication.");
    }
 
    const itineraryData = await response.json();
    const originalItinerary = itineraryData.data?.[0];
 
    if (!originalItinerary) {
      alert("Invalid itinerary data.");
      setIsDuplicating(false);
      return;
    }
 
    const selectedCustomer = customers.find(
      (c) => c.customer_id === selectedCustomerIdForDuplication
    );
    const selectedCustomerName = selectedCustomer?.name || "";
 
    // Duplicate the itinerary
    const duplicatedItinerary = {
      ...originalItinerary,
      customer_id: selectedCustomerIdForDuplication,
      customerName: selectedCustomerName,
    };
 
    delete duplicatedItinerary.itinerary_id;

    console.log("Add Itinerary Data Using token:", token); // Added to print the token
 
    // Save the duplicated itinerary
    const saveResponse = await makeAuthenticatedRequest(
      "https://us-central1-evoq-travel-craft.cloudfunctions.net/add_itinerary_data",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(duplicatedItinerary),
      }
    );
 
    if (!saveResponse.ok) {
      throw new Error("Failed to duplicate itinerary.");
    }

    console.log("Get Itinerary Id Using token:", token); // Added to print the token
 
    // Refresh the itinerary list
    const updatedResponse = await makeAuthenticatedRequest(
      "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_itinerary_id",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
 
    if (!updatedResponse.ok) {
      throw new Error("Failed to fetch updated itineraries.");
    }
 
    const updatedItineraries = await updatedResponse.json();
    setData(updatedItineraries.data || []);
 
    // alert("Itinerary duplicated successfully!");
    setIsDuplicatePopupOpen(false);
  } catch (err) {
    console.error("Error duplicating itinerary:", err.message);
    alert(`Error: ${err.message}`);
  } finally {
    setIsDuplicating(false); // Stop loading
  }
 };
 

  
  
  useEffect(() => {
    if (token) {
      setLoading(true);

      console.log("Get Itinerary Id Using token:", token); // Added to print the token
      makeAuthenticatedRequest(
        "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_itinerary_id",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((responseData) => {
          const sortedData = (responseData.data || []).sort((a, b) => {
            return new Date(b.created_date) - new Date(a.created_date);
          });
          setData(sortedData);
          setLoading(false);
  
          // Highlight recent itinerary only if updatedItineraryId is present
          if (updatedItineraryId) {
            setTimeout(() => {
              const targetRef = itineraryRefs.current[updatedItineraryId];
              if (targetRef) {
                targetRef.scrollIntoView({ behavior: "smooth", block: "center" });
              }
            }, 20); // Delay to ensure DOM is updated
          }
        })
        .catch((err) => {
          setError(err.message);
          setLoading(false);
        });
    }
  }, [token, updatedItineraryId]);
  const handleEdit = (itineraryId) => {
    if (token) {
      console.log("Fetching itinerary data for edit..."); // Log before making the request
      makeAuthenticatedRequest(
        "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_itinerary_data",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ itinerary_id: itineraryId }),
        }
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((responseData) => {
          // Add detailed console logging here
          console.log("Full API Response:", responseData);
          console.log("Response Data Structure:", {
            status: responseData.status,
            message: responseData.message,
            data: responseData.data
          });
          console.log("First Itinerary Item:", responseData.data?.[0]);

          const itineraryDetails = responseData.data?.[0];
          if (itineraryDetails) {
            navigate("/home", {
              state: {
                editData: itineraryDetails,
                token,
              },
            });
          } else {
            console.error("No itinerary details found in response:", responseData);
          }
        })
        .catch((err) => {
          console.error("Error fetching itinerary data:", err.message);
        });
    }
  };
  

  const handleNewButtonClick = () => {
    navigate("/home", { state: location.state });
  };

  const handleGenerateAIButtonClick = async () => {
    console.log("Navigating to Generate AI Page with Token:", token);
  
    if (!token) {
      console.error("Token is missing. Redirecting to login.");
      await doSignOut();
      navigate("/login");
      return;
    }
  
    navigate("/generate-ai", { state: { token } });
  };
  
  const { displayName } = useAuth();

  const filteredData = searchTerm
  ? data.filter((item) => {
      const searchTermLower = searchTerm.toLowerCase();
      const createdDate = new Date(item.created_date).toISOString().split('T')[0]; // Convert to YYYY-MM-DD format
      const duration = item.no_of_days?.toString() || "";  // Ensure it's a string

      return (
        item.customer_name.toLowerCase().includes(searchTermLower) ||
        createdDate.includes(searchTermLower) ||
        duration.includes(searchTermLower) // Add this to check against duration
      );
    })
  : data;


  const handleToggleApprove = async (itineraryId, isApproved) => {
  if (!token) {
    alert("Authorization token is missing.");
    return;
  }

  // Add this itinerary to the loading set
  setApprovingItineraries(prev => new Set([...prev, itineraryId]));

  try {
    const requestBody = { itinerary_id: itineraryId };
    console.log("📤 Approve Itinerary Request Body:", requestBody);

    const response = await makeAuthenticatedRequest(
      "https://us-central1-evoq-travel-craft.cloudfunctions.net/approve_itinerary",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to approve itinerary.");
    }

    const responseData = await response.json();
    console.log("✅ Approve Itinerary Response:", responseData);

    // Refresh list to reflect changes in approval status
    const updatedResponse = await makeAuthenticatedRequest(
      "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_itinerary_id",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (updatedResponse.ok) {
      const updatedData = await updatedResponse.json();
      console.log("🔄 Updated Itinerary List Response:", updatedData);
      setData(updatedData.data || []);
    }

  } catch (error) {
    console.error("❌ Error approving itinerary:", error.message);
    alert(`Error approving itinerary: ${error.message}`);
  } finally {
    // Remove this itinerary from the loading set
    setApprovingItineraries(prev => {
      const newSet = new Set(prev);
      newSet.delete(itineraryId);
      return newSet;
    });
  }
};
  
  

  return (
    <div className="bg-white text-black dark:bg-gray-900 dark:text-white">
      <div className="h-screen flex overflow-hidden">
      {/* Sidebar */}
      <div className="w-72 h-screen flex flex-col bg-gradient-to-b from-white to-blue-50 dark:from-gray-900 dark:to-blue-950 shadow-xl border-r border-blue-100 dark:border-blue-900 transition-all duration-300 py-4 font-['Roboto']">
        {/* Logo Section */}
        <div className="p-6 flex items-center justify-center border-b border-blue-100 dark:border-blue-800">
          <div className="relative group">
            <div className="absolute -inset-1 bg-gradient-to-r from-blue-200 to-blue-400 rounded-xl opacity-50 group-hover:opacity-70 blur transition duration-300"></div>
            {/* <img 
              src="/logo.png" 
              alt="TravelCraft Logo" 
              className="relative w-40 h-auto object-contain z-10"
            /> */}
          </div>
        </div>

        {/* Navigation Buttons */}
        <nav className="flex-1 p-4 space-y-3 mt-6">
          {/* Custom Itinerary Button */}
          <button
            onClick={() => navigate("/home", { state: { token } })}
            className="group w-full flex items-center space-x-3 px-6 py-4 rounded-xl bg-white dark:bg-gray-800 shadow-md hover:shadow-lg transition-all duration-300 border border-blue-100 dark:border-blue-800 hover:border-blue-300 dark:hover:border-blue-600 transform hover:-translate-y-0.5"
          >
            <div className="p-2.5 rounded-lg bg-blue-50 dark:bg-blue-900/50 text-blue-600 dark:text-blue-300 group-hover:bg-blue-100 dark:group-hover:bg-blue-800 transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              </svg>
            </div>
            <div className="text-left overflow-hidden">
              <p className="font-bold text-gray-800 dark:text-gray-200">Custom Itinerary</p>
              <p className="text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap transition-all duration-300 transform translate-y-0 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 h-0 group-hover:h-4">
                Create from scratch
              </p>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-auto text-gray-400 group-hover:text-blue-500 dark:group-hover:text-blue-400 transition-colors" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
            </svg>
          </button>

          {/* Quick Itinerary Button */}
          <button
            onClick={handleGenerateAIButtonClick}
            className="group w-full flex items-center space-x-3 px-6 py-4 rounded-xl bg-white dark:bg-gray-800 shadow-md hover:shadow-lg transition-all duration-300 border border-blue-100 dark:border-blue-800 hover:border-blue-300 dark:hover:border-blue-600 transform hover:-translate-y-0.5"
          >
            <div className="p-2.5 rounded-lg bg-blue-50 dark:bg-blue-900/50 text-blue-600 dark:text-blue-300 group-hover:bg-blue-100 dark:group-hover:bg-blue-800 transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <div className="text-left overflow-hidden">
              <p className="font-bold text-gray-800 dark:text-gray-200">Quick Itinerary</p>
              <p className="text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap transition-all duration-300 transform translate-y-0 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 h-0 group-hover:h-4">
                AI-powered creation
              </p>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-auto text-gray-400 group-hover:text-purple-500 dark:group-hover:text-purple-400 transition-colors" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
            </svg>
          </button>
        </nav>

  {/* Spacer for vertical centering */}
  <div className="flex-1"></div>

  {/* Settings & Logout */}
  <div className="flex flex-col items-center gap-2 mt-auto pb-2 z-10">
    <button
      onClick={() => setShowSettings((prev) => !prev)}
      className="flex items-center gap-2 px-4 py-2 rounded-xl text-blue-900 dark:text-blue-200 bg-gradient-to-r from-blue-100 to-blue-200 dark:from-zinc-800 dark:to-blue-900 hover:bg-blue-200 dark:hover:bg-zinc-700 font-semibold shadow group transition-all duration-200"
    >
      <Cog6ToothIcon className="w-6 h-6 group-hover:rotate-90 transition-transform" />
      <span className="font-poppins text-lg">Settings</span>
    </button>
    {showSettings && (
      <button
        onClick={() => { doSignOut().then(() => navigate('/login')); }}
        className="flex items-center gap-2 px-4 py-2 rounded-xl text-red-600 bg-gradient-to-r from-red-100 to-white hover:bg-red-200 dark:bg-zinc-800 dark:hover:bg-red-900 font-semibold shadow mt-1 animate-fade-in transition-all"
      >
        <ArrowRightOnRectangleIcon className="w-6 h-6" />
        <span className="font-poppins text-lg">Logout</span>
      </button>
    )}
  </div>

  {/* Subtle animated gradient accent at the bottom */}
  
</div>
      {/* Main Content */}
      <div className="w-full min-h-screen p-8 bg-gradient-to-br from-white via-blue-50 to-blue-100 dark:from-gray-900 dark:via-blue-950 dark:to-blue-900 transition-colors font-['Roboto']">
  {/* Header */}
  <div className="flex flex-col sm:flex-row justify-between items-center mb-8 px-6 py-4 rounded-2xl bg-white/80 dark:bg-zinc-900/80 shadow-md backdrop-blur border border-blue-100 dark:border-zinc-800 animate-fade-in">
      <div className="flex items-center gap-4">
      <img src="/people.png" alt="User Avatar" className="w-12 h-12 rounded-full border-2 border-blue-200 shadow" />
      <div className="font-medium">
        <h2 className="text-2xl font-bold tracking-wide text-blue-700 dark:text-blue-200">Welcome, {currentUser?.displayName || "User"}!</h2>
        <div className="text-sm text-gray-500 dark:text-gray-300 italic">Have a great day planning your journeys!</div>
      </div>
    </div>
    <div className="flex items-center gap-4 mt-4 sm:mt-0">
      <div className="text-lg font-mono text-gray-700 dark:text-gray-200 bg-blue-50 dark:bg-zinc-800 px-4 py-1 rounded-xl shadow-inner">
        {currentDateTime}
      </div>
    </div>
  </div>

  {/* Search Bar */}
  <div className="flex items-center mb-8">
    <div className="relative w-full">
      <input
        type="text"
        placeholder="Search by customer name, created date or duration"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="flex-1 px-4 py-2 border border-blue-100 dark:border-zinc-700 rounded-lg pl-10 w-full bg-white/80 dark:bg-zinc-800/80 text-black dark:text-white shadow focus:outline-none focus:ring-2 focus:ring-blue-200 transition"
      />
      <MagnifyingGlassIcon className="w-5 h-5 text-blue-400 absolute left-3 top-1/2 transform -translate-y-1/2 dark:text-blue-200" />
    </div>
  </div>

  {/* Items List */}
  <div className="bg-white/90 dark:bg-zinc-900/90 p-6 rounded-2xl shadow-lg min-h-[400px] max-h-[calc(100vh-290px)] overflow-y-auto border border-blue-100 dark:border-zinc-800 transition-colors">
    {loading ? (
      <div className="flex items-center justify-center h-48 text-lg text-blue-500 font-semibold animate-pulse">Loading...</div>
    ) : filteredData.length > 0 ? (
      <div className="flex flex-col gap-4">
        {filteredData.map((item) => (
          <div
            key={item.itinerary_id}
            ref={(el) => (itineraryRefs.current[item.itinerary_id] = el)}
            className={`flex flex-col md:flex-row justify-between items-center gap-4 border-b border-blue-50 dark:border-zinc-800 py-4 px-2 rounded-xl transition-all duration-150 hover:bg-blue-50/60 dark:hover:bg-zinc-800/60 shadow-sm ${
              item.itinerary_id === updatedItineraryId
                ? "ring-2 ring-blue-300 bg-blue-50/80 dark:bg-blue-950/40"
                : item.itinerary_approval
                ? "bg-blue-100/60 dark:bg-blue-900/40"
                : ""
            }`}
          >
            <div className="flex items-center gap-4 w-full md:w-auto">
              <div className="w-14 h-14 bg-blue-100 dark:bg-blue-900 flex justify-center items-center rounded-full shadow">
  <img src="/airplane.png" alt="Airplane Icon" className="w-9 h-9 object-contain" />
</div>
              <div>
                <h3 className="text-lg font-medium text-blue-900 dark:text-white">{item.customer_name}</h3>
                <div className="flex flex-wrap text-sm text-gray-600 dark:text-gray-300 mt-1 gap-x-6 gap-y-1">
                  <p>Duration: <span className="font-medium text-blue-700 dark:text-blue-200">{item.no_of_days || "-"}</span></p>
                  <p>Created: <span className="font-medium">{new Date(item.created_date).toISOString().split('T')[0]}</span></p>
                  <p>By: <span className="font-medium">{item.created_user || "Kasun Mendis"}</span></p>
                  <p>ID: <span className="font-medium">{item.id || "N/A"}</span></p>
                </div>
              </div>
            </div>
            {/* Buttons */}
            <div className="relative flex-shrink-0">
              {/* Three-dot toggle button */}
              <button
                ref={buttonRef}
                onClick={() =>
                  setOpenMenuId(openMenuId === item.itinerary_id ? null : item.itinerary_id)
                }
                className="text-2xl text-blue-500 hover:text-blue-700 px-2"
                title="Actions"
              >
                &#8942;
              </button>
              {/* Dropdown menu */}
              {openMenuId === item.itinerary_id && (
                <div ref={menuRef} className="absolute right-0 mt-2 w-44 bg-white dark:bg-zinc-800 border border-blue-100 dark:border-zinc-700 rounded-xl shadow-xl z-20 animate-fade-in">
                  <button
                    onClick={() => {
                      handleEdit(item.itinerary_id);
                      setOpenMenuId(null);
                    }}
                    className="block w-full text-left px-4 py-2 text-sm hover:bg-blue-50 dark:hover:bg-zinc-700 rounded-t-xl"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => {
                      setItineraryToDuplicate(item);
                      setIsDuplicatePopupOpen(true);
                      setOpenMenuId(null);
                    }}
                    className="block w-full text-left px-4 py-2 text-sm hover:bg-blue-50 dark:hover:bg-zinc-700"
                  >
                    Duplicate
                  </button>
                  <button
                    onClick={() => {
                      navigate("/costing", { state: { token, itineraryId: item.itinerary_id } });
                      setOpenMenuId(null);
                    }}
                    className="block w-full text-left px-4 py-2 text-sm hover:bg-blue-50 dark:hover:bg-zinc-700"
                  >
                    Costing
                  </button>
                 <div className="flex items-center justify-between px-4 py-2 border-t border-blue-50 dark:border-zinc-700">
  <span className="text-sm font-medium">Confirm</span>
  {approvingItineraries.has(item.itinerary_id) ? (
    <div className="flex items-center justify-center w-9 h-5">
      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
    </div>
  ) : (
    <label className="relative inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        checked={item.itinerary_approval || false}
        onChange={(e) => handleToggleApprove(item.itinerary_id, e.target.checked)}
        className="sr-only peer"
        disabled={approvingItineraries.has(item.itinerary_id)}
      />
      <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 rounded-full peer dark:bg-gray-600 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-500 peer-checked:bg-blue-600"></div>
    </label>
  )}
</div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    ) : (
      <div className="flex items-center justify-center h-32 text-gray-400 italic">No matching itineraries found</div>
    )}
  </div>
</div>
      </div>
      {isDuplicatePopupOpen && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white p-6 rounded shadow-lg w-96 relative">
      <button
        onClick={() => setIsDuplicatePopupOpen(false)}
        className="absolute top-2 right-2 text-gray-600 hover:text-gray-900"
      >
        <i className="fas fa-times text-xl"></i>
      </button>

      <h3 className="text-lg font-bold mb-4">Select Customer</h3>
      <select
        value={selectedCustomerIdForDuplication}
        onChange={(e) => setSelectedCustomerIdForDuplication(e.target.value)}
        className="w-full p-2 border rounded mb-4"
        disabled={isDuplicating}
      >
        <option value="">-- Select a Customer --</option>
        {customers.map((customer) => (
          <option key={customer.customer_id} value={customer.customer_id}>
            {customer.name}
          </option>
        ))}
      </select>

      <div className="flex justify-center">
        {isDuplicating ? (
          <img src="/duplicate.gif" alt="Loading..." className="w-12 h-12" />
        ) : (
          <button
            onClick={handleDuplicateItinerary}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 align-middle"
            disabled={!selectedCustomerIdForDuplication}
          >
            Duplicate
          </button>
        )}
      </div>
    </div>
  </div>
)}


    </div>
  );
};

export default User;